var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLucknowSuperGiantsIplLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 241.657687,
    viewBox: "0 0 299.1 174.9",
    width: 413.80848,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(1 0 0 -1 0 176.9)",
    gradientUnits: "userSpaceOnUse",
    x1: 172.7,
    x2: 281.1,
    y1: 114,
    y2: 114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ededee"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 0 176.9)",
    gradientUnits: "userSpaceOnUse",
    x1: 173.5,
    x2: 294.4,
    y1: 133.1,
    y2: 133.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a31e5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3364c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c75f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d88028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e69c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f0b11d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f8c015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fcc90c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcd05"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 176.9)",
    gradientUnits: "userSpaceOnUse",
    x1: 162.6,
    x2: 299.1,
    y1: 131.5,
    y2: 131.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a31e5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa2552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c24738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d36228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e17826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ea8724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f09021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29220"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1 0 0 -1 0 176.9)",
    gradientUnits: "userSpaceOnUse",
    x1: 172.1,
    x2: 267,
    y1: 99.3,
    y2: 99.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3caa49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48ac48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#68b545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#82bc41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8fc03f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95c13d"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(1 0 0 -1 0 176.9)",
    gradientUnits: "userSpaceOnUse",
    x1: 163,
    x2: 243,
    y1: 84.7,
    y2: 84.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#026735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3caa49"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 126.4,
    x2: 18,
    xlinkHref: "#a",
    y1: 114,
    y2: 114
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 125.7,
    x2: 4.7,
    xlinkHref: "#b",
    y1: 133.1,
    y2: 133.1
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 136.6,
    x2: 0,
    xlinkHref: "#c",
    y1: 131.5,
    y2: 131.5
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 127,
    x2: 32.2,
    xlinkHref: "#d",
    y1: 99.3,
    y2: 99.3
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 135.9,
    x2: 55.2,
    xlinkHref: "#e",
    y1: 84.7,
    y2: 84.7
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(1 0 0 -1 0 176.9)",
    gradientUnits: "userSpaceOnUse",
    x1: 155.9,
    x2: 155.9,
    y1: 26.8,
    y2: 49.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#273f99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#29469d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3254a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#365ba9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3a5eab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3a5fac"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 134.9,
    x2: 134.9,
    xlinkHref: "#k"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 183,
    x2: 183,
    xlinkHref: "#k"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 199.2,
    x2: 199.2,
    xlinkHref: "#k"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 104.6,
    x2: 104.6,
    xlinkHref: "#k"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 192.3,
    x2: 192.3,
    xlinkHref: "#k"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 169.2,
    x2: 169.2,
    xlinkHref: "#k"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 119.5,
    x2: 119.5,
    xlinkHref: "#k"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 228.2,
    x2: 228.2,
    xlinkHref: "#k",
    y1: 26.8,
    y2: 49.6
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 72.5,
    x2: 72.5,
    xlinkHref: "#k",
    y1: 26.8,
    y2: 49.6
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 213.1,
    x2: 213.1,
    xlinkHref: "#k"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 88.9,
    x2: 88.9,
    xlinkHref: "#k"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 108.5,
    x2: 108.5,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.2
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 125.7,
    x2: 125.7,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.2
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 143.2,
    x2: 143.2,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.2
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 201.8,
    x2: 201.8,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.2
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 162.1,
    x2: 162.1,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.2
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 90.6,
    x2: 90.6,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.2
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 181.2,
    x2: 181.2,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.1
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 125.1,
    x2: 125.1,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.2
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientTransform: "matrix(1 0 0 -1 0 176.9)",
    gradientUnits: "userSpaceOnUse",
    x1: 125.1,
    x2: 125.1,
    y1: 69.4,
    y2: 53.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39a9e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2782c5",
    stopOpacity: 0
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 124.7,
    x2: 124.7,
    xlinkHref: "#k",
    y1: 53.1,
    y2: 77.2
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 124.7,
    x2: 124.7,
    xlinkHref: "#E",
    y1: 69.4,
    y2: 53.8
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 107.6,
    x2: 107.6,
    xlinkHref: "#E",
    y1: 68.5,
    y2: 176.9
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 90.5,
    x2: 90.5,
    xlinkHref: "#E",
    y1: 64.5,
    y2: 54.1
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 209.8,
    x2: 209.8,
    xlinkHref: "#E",
    y1: 64.8,
    y2: 54.1
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 197.4,
    x2: 197.4,
    xlinkHref: "#E",
    y1: 67.2,
    y2: 54.1
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 181.1,
    x2: 181.1,
    xlinkHref: "#E",
    y1: 69.5,
    y2: 176.9
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 143,
    x2: 143,
    xlinkHref: "#E",
    y1: 70.5,
    y2: 54.1
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 162.1,
    x2: 162.1,
    xlinkHref: "#E",
    y1: 70.4,
    y2: 54.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h299.1v174.9h-299.1z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m172.7 79.1c6.9-1 46.8-7.1 91.3-15.1 14.5-4.5 17.1-17.2 17.1-17.2l-107.9 27.2-.5 5z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m261.5 29.8c-1 .3-10.4 3.5-62 19.9-6.4 12.7-19 16.2-25.6 17.2s-.4 4.2-.4 4.2c6.3-1.9 85.8-25.8 102.8-30.7 16.2-4.7 18-21.1 18.1-23.9-3.2 1.9-7.6 4.1-13.4 6.4-9.4 3.8-18.4 6.6-19.5 6.9z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m183.1 35v4.7s.3 11.7-12.6 11.9h-8l.6 34h4.1l2.3-23.1s19.6.2 26.6-16.7c56.5-18 63.9-20.5 63.9-20.5s38.1-11.4 39-19.9c-36.4 9.3-116 29.7-116 29.7z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m172.5 81-.4 4.5c12.1-.2 59.3-.8 74.9-1.1 13.2-.5 19.9-14.6 19.9-14.6z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m221.9 88.1c-13-.3-38.7.1-58.9 0l.2 8.3h58.7s6.3-.1 8.9-.5c11.3-1.6 12.2-7.5 12.2-7.5l-21.1-.4z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m126.4 79.1-.5-5-107.9-27.2s2.6 12.7 17.1 17.2c44.5 8 84.4 14 91.3 15.1z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m125.7 71.1s-.4-4.2-.4-4.2c-6.6-1-19.3-4.5-25.6-17.2-51.6-16.4-60.9-19.6-62-19.9-1-.3-10.1-3.1-19.5-6.9-5.8-2.4-10.2-4.5-13.4-6.4.2 2.7 1.9 19.2 18.1 23.9 17 4.9 96.5 28.8 102.8 30.7z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m116 39.6v-4.7s-79.6-20.3-116-29.6c.9 8.5 39 19.9 39 19.9s7.5 2.6 63.9 20.5c7 16.8 26.6 16.7 26.6 16.7l2.2 23.1h4.1l.6-34h-8c-12.9-.2-12.6-11.9-12.6-11.9z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m126.6 81-94.4-11.2s6.7 14.1 19.9 14.6c15.6.3 62.9.9 74.9 1.1z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m76.3 88.1-21.1.4s.9 5.9 12.2 7.5c2.6.4 8.9.5 8.9.5h59.5l.2-8.4c-20.3 0-46.5-.3-59.6 0z",
    fill: "url(#j)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3a5fac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.7 16 3 3c0-.8 0-1.6 0-2.3-1-1-2-2-2.9-3-1 1-2 2-2.9 3v2.3l3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.7 24.5 3-3 3 3c0-.7 0-1.4 0-2.2-1-1-2-2-3-3-1 1-2 2-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.7 13.4c0-.8 0-1.6 0-2.3-1-1-2-2-2.9-3-1 1-2 2-2.9 3v2.3c1-1 2-2 3-3 1 1 2 2 3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.6 29.9c1-1 2.1-2 3.1-3 1 1 2 2 3.1 3 0-.7 0-1.4 0-2.2-1-1-2-2-3-3-1 1-2 2-3 3v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.7 4.8c1 1 1.9 2 2.9 3 .9-.8 1.4-2 1.4-3.3 0-2.5-2-4.5-4.4-4.5s-4.4 2-4.4 4.5.6 2.5 1.4 3.3c1-1 2-2 2.9-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.6 40.8c1.1-1 2.1-2 3.2-3 1 1 2.1 2 3.2 3 0-.7 0-1.4 0-2.2-1.1-1-2.1-2-3.1-3-1 1-2.1 2-3.1 3v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153 45.6c0-.5 0-1 0-1.6-1.1-1-2.1-2-3.2-3-1.1 1-2.1 2-3.2 3v1.6c0 .2 0 .5-.1.7 1.1-1 2.2-2.1 3.3-3.1 1.1 1 2.2 2.1 3.3 3.1v5.7.4c0 1.7-1.5 3.1-3.4 3.1s-3.4-1.4-3.4-3.1c0-.1 0-.2 0-.3 0-1.9 0-3.8 0-5.6-.4 2.3-1.8 4.3-6.3 4.9-.3 11.5-.7 33.9-1.1 45.3h21.4c-.3-11.5-.7-33.9-1-45.3-5-.6-6.1-3-6.4-5.6zm-8.7 25.4c2.1-2.2 5.1-2.8 7.8-1.9-4.7.6-8.6 4.1-10 8.6-.3-2.4.5-4.9 2.2-6.7zm-1.8 8.5c.9-5.5 5.6-9.7 11.2-9.7.3.2.5.4.8.6 0 0-.2 0-.3 0-5.6 0-10.3 3.9-11.7 9.2zm11.7-8.3h1.3c.2.2.4.5.6.7-.5 0-.9 0-1.4 0-5.3 0-9.8 3.5-11.5 8.3 1.2-5.2 5.7-9 11.1-9zm1 11.2c-3.1 3.1-8 3.1-11 0-.2-.2-.4-.5-.6-.7 1.2-5.1 5.7-8.8 11-8.8s1.4 0 2 .2c1.5 3 1.1 6.9-1.4 9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.6 35.3c1.1-1 2.1-2 3.1-3 1 1 2.1 2 3.1 3 0-.7 0-1.4 0-2.2-1-1-2.1-2-3.1-3-1 1-2.1 2-3.1 3z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m154.6 72h1.4c-.2-.3-.4-.5-.6-.7-.4 0-.8 0-1.3 0-5.4 0-9.9 3.9-11.1 9 1.7-4.8 6.2-8.3 11.5-8.3z",
    fill: "#f08821"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m154.2 70.4h.3c-.3-.2-.5-.4-.8-.6-5.6 0-10.3 4.2-11.2 9.7 1.4-5.3 6.2-9.1 11.7-9.1z",
    fill: "#f08821"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m152 69.1c-2.6-.8-5.7-.2-7.8 1.9-1.8 1.8-2.5 4.3-2.2 6.7 1.4-4.6 5.3-8 10-8.6z",
    fill: "#e21f26"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m156.6 73c-.7-.1-1.3-.2-2-.2-5.3 0-9.8 3.8-11 8.8.2.2.4.5.6.7 3 3.2 7.9 3.2 11 0 2.5-2.5 3-6.4 1.4-9.4z",
    fill: "#e21f26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m180.2 131.9c0 1.6 0 2.1-.2 4.8 0 1.1-.2 2.2-.3 3.3h3c-.4-1.2-.8-2.3-1.2-3.5-.7-2.3-.9-2.9-1.4-4.6z",
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m136.4 132.9c-.2-.5-.5-.9-1.3-.9s-.6 0-.8 0c-.1 1.5-.4 3.9-.5 5.3h1.1c1.3-.5 1.6-1.9 1.6-2.8 0-.4 0-1-.2-1.6z",
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m178.5 112c.1.9.3 1.8.4 2.6.2 1 .7 3 1.8 3.9.4.3.9.5 1.3.5s.9-.2 1.2-.5c.8-.9.8-2.8.7-3.9 0-.9-.2-1.8-.3-2.7 0-.6-.6-3.6-1.2-5.2-.2-.4-.9-2.2-2.4-2.2s-.9.2-1.2.6c-.5.6-.7 1.8-.6 4 0 .8.1 1.7.3 2.8z",
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m106.6 132c-.2 0-.2 0-.6 0-.5 2-.9 4.1-1.4 6.1.5 0 1 0 1.4-.2 1.2-.6 1.6-2.2 1.9-3.4.3-1.4.2-2.6-1.2-2.6z",
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m162.5 153.4c-4.2-.1-8.5-.2-12.8-.2s-8.7 0-12.9.2c-.1 7.9-.3 13.2-.4 17.5v.2c.5 1.4 6.2 3.8 13.3 3.8 4.3-.1 10.6-1.3 13.4-3.8 0 0 0-.1 0-.2-.2-5.6-.3-10.4-.5-17.5zm-12.9 17.7c-4.7 0-8.5-1.2-10.1-2 0-.8 0-1.7 0-2.6 3.2.7 6.4 1.1 9.8 1.1 3.6 0 7-.4 10.4-1.2v2.5c-2.3 1.2-6.4 2.1-10.2 2.2z",
    fill: "#3a5fac"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m149.4 167.6c-3.4 0-6.7-.4-9.8-1.1v2.6c1.6.8 5.4 2 10.1 2 3.8-.1 7.9-1 10.2-2.2 0-.8 0-1.6 0-2.5-3.3.8-6.8 1.2-10.4 1.2z",
    fill: "#5582c2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m163.3 138.7s-.1-.1-.1-.2c-2.4.1-2.9.1-5.3 0 0 0 0 .1-.1.2 0 .7.2 1.7.3 3.9v2.2c-.2 0-.4.2-1 .2-3 0-3.1-4.4-3.1-6 0-2.1.2-6.9 4.5-6.9s2.4.4 3.5 1.4c0 0 .1 0 .2-.1 0-.7 0-1.5 0-2.3 0-.9 0-1.7 0-2.6 0 0 0-.1 0-.2-1.5-.9-3.4-1.2-4.9-1.2s-4.4.3-6.5 3c-1.4 1.8-2.5 4.8-2.6 8.7 0 2.7.4 5.3 1.7 7.3 2.3 3.6 6 3.8 7.9 3.8s4.2-.3 6.2-1.1c0 0 0-.1.1-.2-.2-2.3-.3-3.9-.4-6.1s-.1-3.1-.1-4.1z",
    fill: "url(#k)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m142.6 149.5s0-.1.1-.2c-1.1-2.5-1.9-4.7-2.4-6.2-.3-1-.7-2.1-1-3.1.9-.7 2.7-2 2.8-5.8 0-1.4 0-4.5-2.1-5.8-1.1-.7-2.6-.8-4.2-.8s-5.6 0-6.5 0c0 0 0 .1-.1.2-.2 3.3-.8 9-1 11-.2 1.7-1.1 9.2-1.3 10.7 0 0 .1.1.2.2h5.8s.1-.1.2-.2c0-2.8.1-4.1.4-8h.8c.2.8.3 1.5.5 2.3.4 1.6.7 3.2 1.1 4.8 0 .4.2.7.3 1.1 0 0 .1.1.2.2 2.7-.2 3.4-.2 6.1-.3zm-7.6-12.2c-.1 0-.5.2-1.1 0 .1-1.5.4-3.9.5-5.3h.8c.8 0 1.1.4 1.3.9.2.6.2 1.2.2 1.6 0 .9-.3 2.4-1.6 2.8z",
    fill: "url(#l)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m189.8 143.6c-.8-1.8-1.6-3.6-2.3-5.5-1.4-3.3-1.6-3.7-3.7-9-.2-.4-.3-.8-.5-1.2 0 0-.1-.1-.2-.2-2.6 0-3.2 0-6.4 0 0 0 0 .1-.1.2 0 .9-.5 4.9-.6 5.7-.2 1.6-.4 3.1-.6 4.7-.2 1.7-.5 3.5-.7 5.2-.5 3.6-.6 4.1-1 6.1 0 0 .1.1.2.2h5.3s.1-.1.2-.2c0-1.7.2-3.5.4-5.2h4.7c.7 2 1.1 3.2 1.8 5.3 0 0 .1.1.2.2 2.8 0 3.4 0 5.9-.1 0 0 0-.1.1-.2-.1-.3-.6-1.3-.7-1.5-.5-1.2-1.3-3.2-1.9-4.4zm-10-3.6c0-1.1.2-2.2.3-3.3.2-2.7.2-3.2.2-4.8.5 1.7.6 2.3 1.4 4.6.4 1.2.8 2.3 1.2 3.5-1 0-2 0-3 0z",
    fill: "url(#m)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m203.7 127.9s-.1-.1-.2-.2c-1.4 0-2.1 0-4 0 0 0 0 .1-.1.2.3.9 1.4 4.9 1.6 5.7l1.5 5.2c-1.3-1.5-2.6-3.1-3.9-4.6-3.1-3.9-3.6-4.6-4.9-6.5 0 0-.2-.1-.3-.2-2.1 0-2.7 0-4.8 0 0 0 0 .1-.1.2.4 1.9.9 3.9 1.3 5.8s1.6 8 2.1 10.3c.5 2.5.8 4 1.1 5.6 0 0 .1.1.2.2h4.7s.1-.1.2-.2c-.9-3.4-1-3.6-1.9-7.3-.4-1.5-.8-3-1.2-4.5 1.5 1.9 3 3.8 4.6 5.7 1.9 2.4 3 3.6 5 6.2 0 0 .2.1.3.2h4.9s0-.1.1-.2c-.5-1.7-1.2-3.9-2.4-8-.6-2.1-3.3-11.7-3.8-13.6z",
    fill: "url(#n)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m113.1 134.8c1.3-7.1-3.3-7.1-5.6-7.1s-.7 0-1.1 0c-3.2 0-3.5 0-4.7 0 0 0-.1.1-.2.2-.3 1.4-.6 2.5-1 4.1-1.8 6.8-2.7 10.2-4.8 17.5 0 0 0 .1.1.2 2.5 0 3.2-.1 5.8 0 0 0 .1-.1.2-.2.4-2.2.6-3.1 1.5-6.9 1.8 0 3.4 0 5.2-.9 3.6-1.9 4.3-5.8 4.5-7zm-5.3-.2c-.2 1.2-.7 2.8-1.9 3.4-.4.2-.9.2-1.4.2.5-2.1.9-4.1 1.4-6.1h.6c1.4 0 1.5 1.2 1.2 2.6z",
    fill: "url(#o)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m192.3 149.5v-.1z",
    fill: "url(#p)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m170.9 127.9s-.1-.1-.2-.2c-2.5.1-3 .1-5.4 0 0 0 0 .1-.1.2.2 2.2.4 4.4.7 8.3.3 4.5.6 8.9.8 13.4 0 0 .1.1.2.2 2.5 0 3.2-.1 6.1 0 0 0 0-.1.1-.2-.6-4.3-1-8.5-1.5-12.7-.5-4.7-.6-7.3-.8-8.9z",
    fill: "url(#q)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m120.5 127.7c-3 0-3.3 0-4.5 0 0 0-.1.1-.2.2-.5 3.7-1.2 7.9-1.9 11.8-.9 5-1.4 7.5-1.9 9.9 0 0 0 .1.1.2h5.4 6.6s.1-.1.2-.2c.3-1.9.4-2.5.8-4.5 0 0-.1-.1-.2-.2-1.8.2-4.8.2-6.3.2.2-1.5.4-3 .7-4.5h5s.1-.1.2-.2c.3-1.7.4-2.4.7-4.1 0 0 0-.1-.1-.2-1.2 0-3.6.1-5.2.1.2-1.7.3-2.2.6-4.1h2.2 3.1s.1-.1.2-.2c.2-1.6.3-2.2.7-4.2 0 0 0-.1-.1-.2-1.3 0-1.8 0-6.2 0z",
    fill: "url(#r)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m235.8 142.9c-1.5-3.4-3.7-4.7-7.1-6.7-1.7-1-2.7-1.7-3.2-2.8-.4-1.1.1-1.8 1.2-1.8 1.5 0 2.7.8 3.7 1.4h.2c-.3-.7-.5-1.4-.8-2.1-.3-.8-.6-1.6-.9-2.3 0 0-.1-.1-.2-.2-.6-.3-2.3-1-4.6-1s-3.4.6-4 1.8c-.5 1.1-.6 2.7.2 4.9 1.3 3.6 3.7 5 5.4 6.1l1.5.9c1.5.9 2.5 1.5 3 2.6.2.5.6 2.1-1.5 2.1s-3.6-1-4.1-1.4c0 0-.1 0-.2 0 .2.7.5 1.4.7 2 .3.8.5 1.6.7 2.4 0 0 .2.2.3.3 1.5.7 3.3 1 4.9 1s4.3-.4 5.1-2.3c.5-1.1.5-2.8-.4-4.9z",
    fill: "url(#s)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m74.8 133.4c.4-1.1 1.5-1.8 2.6-1.8 1.5 0 2.1.8 2.5 1.4h.3c.3-.7.6-1.4.9-2.1.3-.8.7-1.6 1-2.3 0 0 0-.1 0-.2-.4-.3-1.5-1-3.8-1s-3.8.6-5.4 1.8c-1.4 1.1-2.7 2.7-3.7 4.9-1.5 3.6-.3 5 .6 6.1.3.3.5.6.8.9.8.9 1.3 1.5.9 2.6-.2.5-1.1 2.1-3.2 2.1s-2.8-1-3-1.4h-.2c-.3.7-.6 1.4-.9 2-.4.8-.8 1.6-1.2 2.4v.3c1 .7 2.5 1 4.2 1s4.6-.4 7-2.3c1.4-1.1 2.7-2.8 3.4-4.9 1.2-3.4 0-4.7-1.8-6.7-1-1-1.4-1.7-1-2.8z",
    fill: "url(#t)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m217 137.2c-.8-2.2-1.2-3.7-1.7-5h3.6s0-.1 0-.2c-.7-2-.8-2.4-1.3-4.3 0 0-.1-.1-.2-.2-.8 0-2 0-3 0s-2 0-3 0h-6.6s0 .1-.1.2c.5 1.9.7 2.5 1.1 4.2 0 0 .1.1.2.2h1.7 2.1c.2.7 4.3 14.2 5.2 17.4 0 0 .1.1.2.2h5.9s0-.1.1-.2c-1.5-3.9-3-8.5-4.4-12.4z",
    fill: "url(#u)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m98.7 127.7c-1.7 0-2.2 0-4.4 0 0 0-.1.1-.2.2-.4 1.5-.5 1.8-.9 3-1 3.3-2 6.8-3.1 10.1-.7 2.2-1.4 4.6-3.4 4.6s-1 0-1.2-.7c-.4-.8 0-2.1.9-4.8 1.3-4.1 2.6-8.1 4-12.2 0 0 0-.1 0-.2-2.5 0-3.1 0-5.4 0 0 0-.1.1-.2.2-.6 1.8-1 3-1.8 5.3-1.1 3-1.2 3.3-1.9 5.5-.2.4-.3.9-.5 1.3-1 2.9-1.5 4.3-1.6 5.6-.3 4.5 4.5 4.5 5.8 4.5s4.7 0 7.3-2.8c1.6-1.7 2-3.2 3.2-7.1.1-.5.3-1 .4-1.5 2-6.9 2.4-8.4 3.1-10.8 0 0 0-.1-.1-.2z",
    fill: "url(#v)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m105.5 123.8c1.4 0 5 0 7.4-2.9 1.5-1.8 1.8-3.4 2.6-7.5.1-.5.2-1.1.3-1.6 1.4-7.2 1.7-8.8 2.2-11.4 0 0 0-.1-.1-.2-1.8 0-2.4.1-4.6.1 0 0-.1.1-.2.2-.3 1.5-.4 1.9-.6 3.2-.7 3.5-1.5 7.1-2.3 10.6-.5 2.4-1 4.8-3.2 4.8s-1 0-1.4-.8c-.5-.9-.2-2.2.5-5.1 1-4.3 2-8.6 3-12.9 0 0 0-.1 0-.2-2.6.1-3.2.1-5.7.1 0 0-.1.1-.2.2-.4 1.9-.8 3.2-1.4 5.6-.8 3.2-.9 3.5-1.5 5.8-.1.5-.2.9-.4 1.4-.8 3-1.1 4.5-1.1 5.9.2 4.7 5.2 4.7 6.6 4.7z",
    fill: "url(#w)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m119.3 121c2 2.7 5.1 2.9 7.2 2.9s3.7-.3 4.7-.8c0 0 0-.1.1-.2.3-2.7.4-3.1.7-5.3s-.1 0-.2 0c-1 .7-1.9 1.2-3.5 1.2s-2-.1-2.9-1.1c-1-1.1-1.3-3.2-1-5.7.3-2.4 1-4 1.8-5 .5-.8 1.6-1.9 3.5-1.9s2.5.9 2.9 1.3h.2c.1-.8.2-1.6.4-2.5.1-.9.3-1.9.4-2.8 0 0 0-.1 0-.2-1.4-.8-3.5-.9-4.3-.9-1.9 0-4.4.3-6.8 2.7-3.1 3-4.1 7.5-4.5 9.7-.6 3.2-.5 6.5 1.3 8.8zm-.7-8.7c.2-1.3.6-2.7 1.1-4.2 1.8-.2 3.6-.4 5.4-.5s0 0 0 0c-.5 1-1 2.3-1.3 4.3-.4 2.7 0 5 1.2 6.2 1.1 1.2 2.4 1.3 3.3 1.3s2.1-.3 2.9-.7c-.2 1.2-.3 2-.5 3.9-1 .4-2.5.6-4.2.6s-5-.3-6.7-2.6c-1.4-1.8-1.8-4.6-1.2-8.3z",
    fill: "url(#x)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m140.6 123.4s.1-.1.2-.2c0-2.6 0-4.1.4-10.7.5 1.5 1.1 3 1.6 4.5.7 2 .8 2.3 1.8 5.5.1.3.2.6.3.9 0 0 .1.1.2.2 2.4-.1 3.5-.2 6.9-.3 0 0 0-.1 0-.2-.5-.9-.9-1.8-1.4-2.8-.7-1.5-1.7-3.8-2.4-5.3-.7-1.7-1.4-3.5-2.1-5.2 1-1.7 2-3.5 3-5.2.9-1.6 1.3-2.3 2.3-4.2 0 0 0-.1 0-.2-2.3 0-2.7 0-5.3.1 0 0-.1.1-.2.2-.5 1.2-.6 1.4-1.2 2.8-1.2 2.3-2.4 4.7-3.6 7 .1-1.4.2-2.8.3-4.2 0-.7.3-5.3.4-5.7 0 0 0-.1-.1-.2-2.3.1-3.1.1-5.5.1 0 0-.1.1-.2.2-.1 4-.7 11-.9 12.6-.4 4.3-.8 7.9-1 10.2 0 0 0 .1.1.2 2.8-.1 3.5-.1 6.2 0z",
    fill: "url(#y)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m192 111.7c.7 1.8 1.4 3.6 2 5.3.9 2.4 1 2.6 2 5 .2.4.3.8.5 1.2 0 0 .2.1.2.2 1.8 0 2.9-.1 4.3-.1s1.8 0 2.7 0c0 0 .1-.1.2-.2-.3-3.8-.7-7.6-1-11.5 0-1-.2-2.1-.3-3.1.6 1.5 1.2 3 1.8 4.5.6 1.4 1.1 2.8 1.7 4.2.4.9 2 5.1 2.4 6 0 0 .2.1.2.2 1.9 0 3.1-.1 4.4-.1s1.8 0 2.7 0c0 0 0-.1.1-.2-.1-1.7-.4-4.4-.5-6-.2-1.8-.4-3.7-.6-5.5-.3-2.7-.7-6.9-1.1-9.6 0-.6-.1-1.2-.2-1.8 0 0-.1-.1-.2-.2-2.1 0-2.5 0-4.6.1 0 0 0 .1-.1.2.4 2.2.5 3 1.1 7.3.6 5 .8 6.4 1.3 9.4-.4-.9-.8-1.8-1.1-2.7-2.4-5.5-2.9-6.7-5.9-14.2 0 0-.1-.1-.2-.2-2.4 0-3 .1-5.8.1 0 0 0 .1-.1.2.7 6.8.8 8 1.4 14.6 0 .7 0 1.5.1 2.2-.3-.8-.6-1.5-.8-2.3-.9-2.5-1.8-5-2.7-7.5-.9-2.4-1.8-5-2.5-7.2 0 0-.1-.1-.2-.2-2.5.2-2.9.2-5.4.3 0 0 0 .1-.1.2.7 1.9.9 2.4 2.5 6.7.6 1.5 1.1 3 1.7 4.5z",
    fill: "url(#z)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m153.4 117.4v5.9s.1.1.2.2h5s.1-.1.2-.2c-.3-3.6-.3-3.8-.5-7.7-.1-1.6-.2-3.2-.3-4.8l3.6 6c1.6 2.5 2.4 3.8 4 6.6 0 0 .2.1.2.2h5.2s.1-.1.2-.2c-.2-1.8-.5-4.2-.9-8.5-.2-2.3-1-12.3-1.2-14.4 0 0-.1-.1-.2-.2-1.4 0-2.2 0-4.3.1 0 0-.1.1-.2.2.1.9.5 5.2.6 6 .2 1.8.3 3.7.5 5.5-1.1-1.6-2.1-3.3-3.1-4.9-2.5-4.1-2.9-4.9-3.8-6.8 0 0-.2-.1-.2-.2-2.2.1-2.9.1-5.1.1 0 0-.1.1-.2.2 0 2 .1 4.1.2 6.1 0 2 .1 8.4.1 10.9z",
    fill: "url(#A)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m86.9 123.4h8.8s.2-.1.2-.2c.6-2.1.8-2.7 1.5-4.7 0 0 0-.1-.1-.2-2 .1-3.9.2-5.9.2.3-1 .5-1.8.6-2.2.2-.8.5-1.6.8-2.5.6-1.9 3.1-10.4 3.6-12.1.1-.5.3-.9.4-1.3s0-.1-.1-.2c-2.1.1-2.9.1-5.6.1 0 0-.2.1-.2.2-.4 1.3-.6 1.9-1.1 3.7-.3.9-.6 1.9-.9 2.8-.5 1.5-2.7 8.3-3.1 9.7-.9 2.8-1.3 4-2.2 6.7 0 0 0 .1.1.2h3.2z",
    fill: "url(#B)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m175.3 120.6c2.8 3.1 6.3 3.2 7.3 3.2s4.7 0 6.5-3.2c.7-1.2 1-2.7 1-4.3 0-1.4-.1-2.9-.4-4.3-.3-1.7-1.3-6.7-4.4-9.7-2.5-2.4-5.1-2.5-6.2-2.5s-3.7.2-5.4 2.6c-2.1 3-1.8 7.9-1.6 9.7.4 4.2 1.7 6.9 3.1 8.5zm3.5-15.5c.3-.4.7-.6 1.2-.6 1.5 0 2.2 1.8 2.4 2.2.6 1.6 1.1 4.6 1.2 5.2.1.9.2 1.8.3 2.7 0 1.2.1 3.1-.7 3.9-.3.3-.7.5-1.2.5s-.9-.2-1.3-.5c-1.1-.9-1.6-2.9-1.8-3.9-.2-.9-.3-1.7-.4-2.6-.1-1.1-.2-2-.3-2.8-.1-2.2.1-3.4.6-4z",
    fill: "url(#C)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m125.1 107.5h-.1z",
    fill: "url(#D)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m125.1 107.5h-.1z",
    fill: "url(#E)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m126.4 123.1c1.7 0 3.2-.2 4.2-.6.2-1.9.3-2.6.5-3.9-.8.4-1.7.7-2.9.7s-2.2-.1-3.3-1.3-1.5-3.5-1.2-6.2c.3-1.9.8-3.3 1.3-4.3-1.8.2-3.6.3-5.4.5-.6 1.5-.9 3-1.1 4.2-.6 3.7-.2 6.5 1.2 8.3 1.7 2.3 4.3 2.6 6.7 2.6z",
    fill: "url(#F)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m126.4 123.1c1.7 0 3.2-.2 4.2-.6.2-1.9.3-2.6.5-3.9-.8.4-1.7.7-2.9.7s-2.2-.1-3.3-1.3-1.5-3.5-1.2-6.2c.3-1.9.8-3.3 1.3-4.3-1.8.2-3.6.3-5.4.5-.6 1.5-.9 3-1.1 4.2-.6 3.7-.2 6.5 1.2 8.3 1.7 2.3 4.3 2.6 6.7 2.6z",
    fill: "url(#G)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m110.8 114.4c-.5 2.4-1.1 5.3-3.8 5.3s-1.7-.6-1.9-1.1c-.6-1.1-.3-2.6.4-5.5.3-1.1.5-2.2.7-3.3-1.7.3-3.3.6-5 .9 0 .4-.2.8-.3 1.3l-.4 1.4c-.8 3.1-1.1 4.5-1.1 5.7 0 2.8 2 4.1 6 4.1s4.7 0 7-2.7c1.4-1.6 1.7-3.2 2.5-7.2l.3-1.6.6-3.2c-1.3.2-2.6.3-3.9.5-.4 1.8-.8 3.6-1.2 5.4z",
    fill: "url(#H)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m90.5 119.1.2-.8c.3-1 .5-1.7.6-2.2.1-.4.3-.9.4-1.3s.2-.8.4-1.2c0-.3.2-.6.3-1.1-1.8.4-3.5.8-5.2 1.3-.4 1.4-.8 2.6-1 3.1-.8 2.5-1.2 3.7-2 6h.3 2.2s8.5 0 8.5 0c.5-1.6.7-2.3 1.2-3.8-1.7.1-3.5.1-5.2.1h-.8z",
    fill: "url(#I)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m214.7 118.7v-1.5c-.2-.9-.3-1.7-.4-2.6-1.1-.3-2.2-.6-3.3-.9.2 1.1.3 2 .5 3.3l-1.2.4c-.4-.9-.7-1.8-1.1-2.7l-.6-1.4c0-.1 0-.2-.1-.3-1.3-.3-2.6-.6-4-.9 0 .2.2.5.3.7l.2.4c.5 1.2 1 2.5 1.5 3.7.4 1 1.8 4.6 2.3 5.8 1.7 0 2.8-.1 4.1-.1s1.5 0 2.2 0c0-1.2-.2-2.6-.3-4z",
    fill: "url(#J)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m202 111.7c-.8-.2-1.7-.3-2.5-.5 0 1.1.2 2.3.3 3.9 0 .7 0 1.5.1 2.2l-1.2.3c-.3-.8-.6-1.5-.8-2.3-.3-.9-.7-1.8-1-2.8-.2-.6-.5-1.3-.7-1.9-1.5-.3-2.9-.5-4.4-.8.2.6.4 1.1.7 1.7.7 1.8 1.4 3.6 2 5.3.3.7.4 1.2.6 1.6.4 1.1.7 1.7 1.4 3.4 0 .2.2.4.2.6 0 .1.1.3.2.4 1.6 0 2.7-.1 4-.1s1.4 0 2.2 0c-.3-3.8-.7-7.6-1-10.9 0 0 0 0 0-.1z",
    fill: "url(#K)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m188.5 109.2c-1.6-.2-3.3-.5-4.9-.7.4 1.6.6 3.1.6 3.2.1 1 .3 1.8.3 2.7 0 1.6 0 3.5-.9 4.4-.4.4-1 .7-1.6.7s-1.2-.2-1.7-.6c-1.2-1-1.7-2.8-2.1-4.3-.2-.9-.3-1.8-.4-2.7-.1-1-.2-2-.3-2.9 0-.5 0-.9 0-1.3-1.5-.2-3.1-.3-4.7-.4-.1 1.4-.1 2.9 0 4.6.3 3.5 1.4 6.3 2.9 8.1 1.7 2 4 3 6.9 3s4.9-1 6-2.9c.6-1 .9-2.4.9-3.9 0-1.2 0-2.5-.4-4.2-.2-1-.4-2-.7-2.8z",
    fill: "url(#L)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m147.8 115.2c-.7-1.7-1.4-3.5-2.1-5.2v-.3c-.1 0 0-.3 0-.3.6-1 1.1-1.9 1.7-2.9-1.2 0-2.4 0-3.6 0-.7 1.3-1.4 2.7-2.1 4l-1.2-.4.3-3.6c-1.5 0-3 .1-4.5.2-.2 2.7-.4 5.3-.5 6.4-.3 3.2-.6 6.2-.8 8.3 0 .5 0 .9-.1 1.3h3.5s1 0 1.7 0c0-2.3 0-4 .4-10.3l1.2-.2c.5 1.5 1.1 3 1.7 4.5.5 1.3.7 1.9 1.1 3.1.2.6.4 1.3.8 2.3 0 .2.1.3.2.5v.2c1.7 0 2.8-.1 4.7-.2h1.1c-.3-.7-.7-1.4-1-2.1-.7-1.4-1.7-3.8-2.4-5.3z",
    fill: "url(#M)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m169.6 114.8c0-1.1-.3-4-.6-6.9 0-.2 0-.4 0-.7-1.1 0-2.2-.1-3.3-.2.1 1.7.3 3.3.4 5l-1.2.4c-1.1-1.6-2.1-3.3-3.1-4.9-.2-.3-.3-.5-.4-.7-2.5-.1-5-.2-7.5-.2v5.1 5.8 5.4h4.1v-1.3c-.3-2-.3-2.8-.5-5.9-.1-1.6-.2-3.2-.3-4.8l1.2-.4 3.6 6 .5.8c1.2 2 2 3.3 3.5 5.7h4.4v-.4c-.2-1.7-.5-3.9-.8-7.5z",
    fill: "url(#N)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucknowSuperGiantsIplLogo);
export default __webpack_public_path__ + "static/media/Lucknow_Super_Giants_IPL_Logo.c2eb46934712c7e4af90c1a8a9ed0ba3.svg";
export { ForwardRef as ReactComponent };